import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment AutopilotSuggestionEnableMeeting_org on Org {
      id
      experiments
    }
  `,
  autopilotMeetingKnob: graphql`
    fragment AutopilotSuggestionEnableMeeting_autopilotMeetingKnob on AutopilotMeetingKnob {
      __typename
      knobUrn {
        id
        type
        value
      }
      externalEventId
      affectedGoals
      knobScore
    }
  `,
  referencedEvents: graphql`
    fragment AutopilotSuggestionEnableMeeting_referencedEvents on Event @relay(plural: true) {
      title
      startTime {
        millis
      }
      endTime {
        millis
      }
      eventKey {
        externalEventId
      }
      attendees {
        displayName
        profileId
        optional
        organizer
        resource
        responseStatus
        urnType
        urnValue
      }
      suggestedAutopilotSettingsResponseV3 {
        __typename
        ... on SuggestedAutopilotSettingsResponseV3 {
          intersectionOfAttendeesMeetingHours {
            minSlot {
              dayOffset
              timeSlot
            }
            maxSlot {
              dayOffset
              timeSlot
            }
          }
          calendarIdToMeetingHours {
            calendarId
            dayOffsetTimeSlotRanges {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
          }
          suggestedAutopilotSettings {
            isRoomFlexible
            movementType
            allowedEndTime {
              dayOffset
              timeSlot
            }
            allowedStartTime {
              dayOffset
              timeSlot
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
      moveRangeInLocalTimeV3 {
        __typename
        ... on MoveRangeInLocalTimeV3 {
          allowedStartTimeInclusive {
            dayOffset
            timeSlot
          }
          allowedEndTimeInclusive {
            dayOffset
            timeSlot
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};
